type InvoiceType = 'origin' | 'destination';

export const getEnvironmentBaseUrl = (): string => {
    const { hostname } = window.location;

    if (hostname.includes('localhost') || hostname.includes('test')) {
        return 'https://scm-test.maersk.com';
    } else if (hostname.includes('preprod')) {
        return 'https://scm-preprod.maersk.com';
    } else {
        return 'https://scm.maersk.com';
    }
};

export const redirectToViewInvoice = (
    type: InvoiceType, 
    invoice: string
) => {    
    const baseUrl = getEnvironmentBaseUrl();
    const redirectUrl = `${baseUrl}/scp/cshub/billing/billing/view-invoice/${type}/${invoice}`;
    window.location.assign(redirectUrl);
};

export const redirectToCombineInvoice = (
    type: InvoiceType, 
    queryParams: URLSearchParams | Record<string, string>
) => {
    const baseUrl = getEnvironmentBaseUrl();
    const queryString = queryParams instanceof URLSearchParams ? queryParams.toString() : new URLSearchParams(queryParams).toString();
    const redirectUrl = `${baseUrl}/scp/cshub/billing/billing/issue-invoice/${type}/combine-invoice?${queryString}`;
    window.location.assign(redirectUrl);
}

